module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Sopranos-The-S2.bda56f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Sopranos-The-S2.jpg
// module id = qe24
// module chunks = 0